//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './StatisticsViewerClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type DeleteReportStatisticsViewerQueryParameters = {
  reportName: string ;
}

export function getReportsUrl(): string {
  let url_ = getBaseUrl() + "/api/statistics/viewer/reports";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getReportsDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfReportListDto, unknown, Types.PageableListDtoOfReportListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfReportListDto, unknown, Types.PageableListDtoOfReportListDto>, 'queryFn'>> = {
};
export function getGetReportsDefaultOptions() {
  return getReportsDefaultOptions;
};
export function setGetReportsDefaultOptions(options: typeof getReportsDefaultOptions) {
  getReportsDefaultOptions = options;
}

export function getReportsQueryKey(): QueryKey;
export function getReportsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'StatisticsViewerClient',
      'getReports',
    ]);
}
export function __getReports(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getReports(
axiosConfig    );
}

export function useGetReportsQuery<TSelectData = Types.PageableListDtoOfReportListDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.PageableListDtoOfReportListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetReportsQuery<TSelectData = Types.PageableListDtoOfReportListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfReportListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfReportListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getReports(context, axiosConfig) : __getReports,
    queryKey: getReportsQueryKey(),
    ...getReportsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfReportListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetReportsData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfReportListDto | undefined) => Types.PageableListDtoOfReportListDto, ) {
  queryClient.setQueryData(getReportsQueryKey(),
    updater
  );
}

export function setGetReportsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfReportListDto | undefined) => Types.PageableListDtoOfReportListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function deleteReportUrl(reportName: string): string {
  let url_ = getBaseUrl() + "/api/statistics/viewer/reports/{reportName}";
if (reportName === undefined || reportName === null)
  throw new Error("The parameter 'reportName' must be defined.");
url_ = url_.replace("{reportName}", encodeURIComponent("" + reportName));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteReportMutationKey(reportName: string): MutationKey {
  return trimArrayEnd([
      'StatisticsViewerClient',
      'deleteReport',
      reportName as any,
    ]);
}

export function useDeleteReportMutation<TContext>(reportName: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteReportMutationKey(reportName);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteReport(reportName),
    mutationKey: key,
  });
}
  
type DeleteReport__MutationParameters = DeleteReportStatisticsViewerQueryParameters

export function useDeleteReportMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteReport__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteReportStatisticsViewerQueryParameters}): UseMutationResult<void, unknown, DeleteReport__MutationParameters, TContext> {
  const key = deleteReportMutationKey(options?.parameters?.reportName!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteReport__MutationParameters) => Client.deleteReport(data.reportName ?? options?.parameters?.reportName!),
  mutationKey: key,
});
}